module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADwSURBVEhL7ZK7DkFBFEWvBgktOgoqoZWImt+gofAJfkSjFxUfoVSIRyLxISLxWnvuw43OvUPDSlZmTrMnZ85x/ryQwxUuTWUZhe/wjnrEKuFwnaqtobAtfiU8j9b4hztDVMAM/cFZC++hQi7eqbAqbrx6j5HDG3jCKZZxjQq9emes8AIecWAqlwr6ndywhpFI4gTDAQmco8LD3+XP5C2amHWvASNU6ALVif9dGnxsOnhGPaJOhGaiTjTsWJTwgG1TPdHg1UHfVBFJ4RiLpnqiwWu7uqaKgWaRdq8BddR2aYWtk0Ftl1b4I7RQK/yTOM4DLyFCwU2Pf5cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-pitchfork/dark/24.png
// module id = 2340
// module chunks = 2